
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Stop devices from sleeping to ensure interaction works
var $fd06e94fc6bbfbdb$exports = {};
var $c5856b681c11bdda$exports = {};
$c5856b681c11bdda$exports = {
    webm: "data:video/webm;base64,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",
    mp4: "data:video/mp4;base64,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"
};


var $fd06e94fc6bbfbdb$require$webm = $c5856b681c11bdda$exports.webm;
var $fd06e94fc6bbfbdb$require$mp4 = $c5856b681c11bdda$exports.mp4;
// Detect iOS browsers < version 10
const $fd06e94fc6bbfbdb$var$oldIOS = ()=>typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
        0,
        ""
    ])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
// Detect native Wake Lock API support
const $fd06e94fc6bbfbdb$var$nativeWakeLock = ()=>"wakeLock" in navigator;
class $fd06e94fc6bbfbdb$var$NoSleep {
    constructor(){
        this.enabled = false;
        if ($fd06e94fc6bbfbdb$var$nativeWakeLock()) {
            this._wakeLock = null;
            const handleVisibilityChange = ()=>{
                if (this._wakeLock !== null && document.visibilityState === "visible") this.enable();
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
            document.addEventListener("fullscreenchange", handleVisibilityChange);
        } else if ($fd06e94fc6bbfbdb$var$oldIOS()) this.noSleepTimer = null;
        else {
            // Set up no sleep video element
            this.noSleepVideo = document.createElement("video");
            this.noSleepVideo.setAttribute("title", "No Sleep");
            this.noSleepVideo.setAttribute("playsinline", "");
            this._addSourceToVideo(this.noSleepVideo, "webm", $fd06e94fc6bbfbdb$require$webm);
            this._addSourceToVideo(this.noSleepVideo, "mp4", $fd06e94fc6bbfbdb$require$mp4);
            this.noSleepVideo.addEventListener("loadedmetadata", ()=>{
                if (this.noSleepVideo.duration <= 1) // webm source
                this.noSleepVideo.setAttribute("loop", "");
                else // mp4 source
                this.noSleepVideo.addEventListener("timeupdate", ()=>{
                    if (this.noSleepVideo.currentTime > 0.5) this.noSleepVideo.currentTime = Math.random();
                });
            });
        }
    }
    _addSourceToVideo(element, type, dataURI) {
        var source = document.createElement("source");
        source.src = dataURI;
        source.type = `video/${type}`;
        element.appendChild(source);
    }
    get isEnabled() {
        return this.enabled;
    }
    enable() {
        if ($fd06e94fc6bbfbdb$var$nativeWakeLock()) return navigator.wakeLock.request("screen").then((wakeLock)=>{
            this._wakeLock = wakeLock;
            this.enabled = true;
            console.log("Wake Lock active.");
            this._wakeLock.addEventListener("release", ()=>{
                // ToDo: Potentially emit an event for the page to observe since
                // Wake Lock releases happen when page visibility changes.
                // (https://web.dev/wakelock/#wake-lock-lifecycle)
                console.log("Wake Lock released.");
            });
        }).catch((err)=>{
            this.enabled = false;
            console.error(`${err.name}, ${err.message}`);
            throw err;
        });
        else if ($fd06e94fc6bbfbdb$var$oldIOS()) {
            this.disable();
            console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `);
            this.noSleepTimer = window.setInterval(()=>{
                if (!document.hidden) {
                    window.location.href = window.location.href.split("#")[0];
                    window.setTimeout(window.stop, 0);
                }
            }, 15000);
            this.enabled = true;
            return Promise.resolve();
        } else {
            let playPromise = this.noSleepVideo.play();
            return playPromise.then((res)=>{
                this.enabled = true;
                return res;
            }).catch((err)=>{
                this.enabled = false;
                throw err;
            });
        }
    }
    disable() {
        if ($fd06e94fc6bbfbdb$var$nativeWakeLock()) {
            if (this._wakeLock) this._wakeLock.release();
            this._wakeLock = null;
        } else if ($fd06e94fc6bbfbdb$var$oldIOS()) {
            if (this.noSleepTimer) {
                console.warn(`
          NoSleep now disabled for older iOS devices.
        `);
                window.clearInterval(this.noSleepTimer);
                this.noSleepTimer = null;
            }
        } else this.noSleepVideo.pause();
        this.enabled = false;
    }
}
$fd06e94fc6bbfbdb$exports = $fd06e94fc6bbfbdb$var$NoSleep;


const $ead1caf1e4ba1e7b$var$noSleep = new (0, (/*@__PURE__*/$parcel$interopDefault($fd06e94fc6bbfbdb$exports)))();
// Firebase configuration
const $ead1caf1e4ba1e7b$var$firebaseConfig = {
    apiKey: "AIzaSyD67qXtbzoLkaLn07Yau95syE8UTHY7Kpg",
    authDomain: "mwrc-breathe.firebaseapp.com",
    databaseURL: "https://mwrc-breathe-default-rtdb.firebaseio.com",
    projectId: "mwrc-breathe",
    storageBucket: "mwrc-breathe.appspot.com",
    messagingSenderId: "64698781076",
    appId: "1:64698781076:web:b16c5c9753da2375135381"
};
// Initialize firebaseConfig
firebase.initializeApp($ead1caf1e4ba1e7b$var$firebaseConfig);
// initialize database
const $ead1caf1e4ba1e7b$var$database = firebase.database();
// get user's data
const $ead1caf1e4ba1e7b$var$username = Date.now();
// Reference the collection created earlier
const $ead1caf1e4ba1e7b$var$fetchMessages = $ead1caf1e4ba1e7b$var$database.ref("messages/");
const $ead1caf1e4ba1e7b$var$fetchUsers = $ead1caf1e4ba1e7b$var$database.ref("users/");
// Get dom element
const $ead1caf1e4ba1e7b$var$informationButton = document.querySelector(".informationButton");
// RGBA color array
const $ead1caf1e4ba1e7b$var$colorArray = [
    "255, 151, 210, 1",
    "231, 255, 82, 1",
    "228, 75, 162, 1",
    "255, 197, 82, 1",
    "44, 193, 118, 1",
    "133, 221, 233, 1",
    "82, 152, 255, 1",
    "137, 127, 246, 1",
    "157, 15, 101, 1"
];
// Data to be sent
let $ead1caf1e4ba1e7b$var$average = 0;
let $ead1caf1e4ba1e7b$var$gradientSetter;
let $ead1caf1e4ba1e7b$var$left = 0;
let $ead1caf1e4ba1e7b$var$userCount = 1;
let $ead1caf1e4ba1e7b$var$activeUsers = 0;
function $ead1caf1e4ba1e7b$var$shuffle(array) {
    let currentIndex = array.length;
    // While there remain elements to shuffle...
    while(currentIndex != 0){
        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
}
function $ead1caf1e4ba1e7b$var$randomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $ead1caf1e4ba1e7b$var$deviceOrientationHandler() {
    $ead1caf1e4ba1e7b$var$left = event.alpha;
}
function $ead1caf1e4ba1e7b$var$deviceOrientation() {
    if (typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then((permissionState)=>{
        if (permissionState === "granted") window.addEventListener("deviceorientation", $ead1caf1e4ba1e7b$var$deviceOrientationHandler);
    }).catch(console.error);
    else // handle regular non iOS 13+ devices
    window.addEventListener("deviceorientation", $ead1caf1e4ba1e7b$var$deviceOrientationHandler);
}
function $ead1caf1e4ba1e7b$var$deviceAudio() {
    navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    }).then(function(stream) {
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);
        const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);
        $ead1caf1e4ba1e7b$var$shuffle($ead1caf1e4ba1e7b$var$colorArray);
        const color1 = $ead1caf1e4ba1e7b$var$colorArray[0];
        const color2 = $ead1caf1e4ba1e7b$var$colorArray[2];
        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;
        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(audioContext.destination);
        scriptProcessor.onaudioprocess = function() {
            const array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            const arraySum = array.reduce((a, value)=>a + value, 0);
            $ead1caf1e4ba1e7b$var$average = arraySum / array.length * 100;
            $ead1caf1e4ba1e7b$var$gradientSetter = `linear-gradient(${$ead1caf1e4ba1e7b$var$left}deg, rgba(${color1}) 0%, rgba(${color2}) ${100 - $ead1caf1e4ba1e7b$var$average / 100}%)`;
            if (window.innerWidth < window.innerHeight) document.querySelector("#hashPhone").style.setProperty("--volume", $ead1caf1e4ba1e7b$var$average / window.innerWidth * 50 + "vw");
            $ead1caf1e4ba1e7b$var$sendMessage();
        };
    }).catch(function(err) {
        /* handle the error */ console.error(err);
    });
}
// fetchMessages.on("child_added", () => {
//   fetchUsers.once("value", (snapshot) => {
//     const userCount = snapshot.val().counter
//       ? snapshot.val().counter.userCount + 1
//       : 1;
//     console.log(userCount);
//     sendUsers(userCount);
//   });
// });
// Send values to database
function $ead1caf1e4ba1e7b$var$sendUsers(userCount) {
    // Create database collection and send in the data
    $ead1caf1e4ba1e7b$var$database.ref("users/counter").set({
        userCount: userCount
    });
}
function $ead1caf1e4ba1e7b$var$clearMessages() {
    // Wipe the messages data by setting it to nothing
    $ead1caf1e4ba1e7b$var$database.ref("messages").set({});
}
// Send values to database
function $ead1caf1e4ba1e7b$var$sendMessage() {
    const minVolume = $ead1caf1e4ba1e7b$var$average > 10 ? $ead1caf1e4ba1e7b$var$average : 5;
    const volume = $ead1caf1e4ba1e7b$var$average;
    const gradient = $ead1caf1e4ba1e7b$var$gradientSetter;
    document.querySelector("#data").innerText = `Left: ${$ead1caf1e4ba1e7b$var$left * 100 / 360}%
  Width: ${minVolume / window.innerWidth * 25 + 5}vw
  Bottom: ${minVolume / window.innerWidth * 25 + 2.5}vw
  Color: ${gradient}
  Blur: ${minVolume / window.innerWidth * 25 + 5 / 8}
  Active Users: ${$ead1caf1e4ba1e7b$var$activeUsers}
  Total Users: ${$ead1caf1e4ba1e7b$var$userCount}`;
    // Create database collection and send in the data
    $ead1caf1e4ba1e7b$var$database.ref("messages/" + $ead1caf1e4ba1e7b$var$username).set({
        username: $ead1caf1e4ba1e7b$var$username,
        volume: volume,
        gradient: gradient,
        left: $ead1caf1e4ba1e7b$var$left
    });
}
function $ead1caf1e4ba1e7b$var$removeUser(username) {
    $ead1caf1e4ba1e7b$var$database.ref("messages/" + username).remove();
}
function $ead1caf1e4ba1e7b$var$checkHash() {
    const currentUrl = location.hash;
    if (currentUrl) document.querySelector("body").classList.add("sending-data");
}
function $ead1caf1e4ba1e7b$var$wrapLetters() {
    // Wrap every letter in a span
    const title = document.querySelectorAll(".animateTextItem");
    title.forEach((eachTitle)=>{
        eachTitle.innerHTML = eachTitle.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
    });
}
function $ead1caf1e4ba1e7b$var$connect(event1) {
    // Update button style
    event1.target.innerText = "...";
    event1.target.classList.add("connecting");
    // Ask for device orientation data
    $ead1caf1e4ba1e7b$var$deviceOrientation();
    // Ask for microphone data
    $ead1caf1e4ba1e7b$var$deviceAudio();
    // Stop multiple clicks
    event1.target.disabled = true;
    // Disable phone sleep mode
    $ead1caf1e4ba1e7b$var$noSleep.enable();
    // Update DOM
    event1.target.classList.add("connected");
    event1.target.innerText = "";
    $ead1caf1e4ba1e7b$var$fetchUsers.once("value", (snapshot)=>{
        $ead1caf1e4ba1e7b$var$userCount = snapshot.val().counter ? snapshot.val().counter.userCount + 1 : 1;
        console.log($ead1caf1e4ba1e7b$var$userCount);
        $ead1caf1e4ba1e7b$var$sendUsers($ead1caf1e4ba1e7b$var$userCount);
    });
}
// Create QR code image from URL
new QRCode(document.getElementById("qrCode"), window.location.href + "#" + $ead1caf1e4ba1e7b$var$username);
// Add alt text to QR image
document.querySelector("#qrCode img").setAttribute("alt", "QR Code");
$ead1caf1e4ba1e7b$var$checkHash();
$ead1caf1e4ba1e7b$var$wrapLetters();
// Event Listeners
$ead1caf1e4ba1e7b$var$informationButton.addEventListener("click", ()=>{
    if (!document.querySelector("#information").classList.contains("showInformation")) document.querySelector("#information").classList.add("showInformation");
    else document.querySelector("#information").classList.remove("showInformation");
});
// Copy URL in information model
document.querySelector(".copyUrl").addEventListener("click", ()=>{
    navigator.clipboard.writeText(window.location.href);
    document.querySelector(".copyUrl").innerText = "Copied URL";
});
document.querySelectorAll(".connectButton").forEach((connectButton)=>{
    connectButton.addEventListener("click", $ead1caf1e4ba1e7b$var$connect, false);
});
// When Firebase is updated, update CSS variables
$ead1caf1e4ba1e7b$var$fetchMessages.limitToLast(25).on("child_changed", (snapshot)=>{
    // console.log("child_changed");
    // console.log("update DOM");
    // Limit the volume
    const minVolume = snapshot.val().volume > 10 ? snapshot.val().volume : 5;
    // Set CSS variables for each user from database
    document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "volume", minVolume / window.innerWidth * 25 + 5 + "vw");
    document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "color", snapshot.val().gradient);
    // If device orientation
    if (snapshot.val().left != 0) document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "left", snapshot.val().left * 100 / 360 + "%");
    else document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "left", "46%");
});
// Check for new data from Firebase using the onChildAdded event listener
$ead1caf1e4ba1e7b$var$fetchMessages.limitToLast(25).on("child_added", (snapshot)=>{
    console.log("child added");
    // Check if user is older than 5 min
    const timer = Date.now() - 300000;
    if (snapshot.val().username < timer) console.log("remove user");
    else {
        // console.log("update DOM");
        const message = `<li style="z-index:-${$ead1caf1e4ba1e7b$var$activeUsers}; left: var(--${snapshot.val().username}left); bottom: calc(var(--${snapshot.val().username}volume) / 2); filter: blur(calc(var(--${snapshot.val().username}volume) / 8)); background: var(--${snapshot.val().username}color); width: var(--${snapshot.val().username}volume); height: var(--${snapshot.val().username}volume)" class="user${snapshot.val().username}"></li>`;
        // Append the message on the page
        document.getElementById("messages").innerHTML += message;
        $ead1caf1e4ba1e7b$var$activeUsers++;
        const minVolume = snapshot.val().volume > 10 ? snapshot.val().volume : 5;
        // Set CSS variables for each user from database
        document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "volume", minVolume / window.innerWidth * 25 + 5 + "vw");
        document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "color", snapshot.val().gradient);
        // If device orientation
        if (snapshot.val().left != 0) document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "left", snapshot.val().left * 100 / 360 + "%");
        else document.querySelector("#messages").style.setProperty("--" + snapshot.val().username + "left", "46%");
    // console.log(`${(snapshot.val().left * 100) / 360}%`);
    }
});
// Check for new data from Firebase using the value event listener
// fetchMessages.once("value", (snapshot) => {
//   console.log("value once");
//   if (!snapshot.val()) return;
//   const message = `<li style="style="z-index:${activeUsers}; left: var(--${
//     snapshot.val().username
//   }left); bottom: calc(var(--${
//     snapshot.val().username
//   }volume) / 2); filter: blur(calc(var(--${
//     snapshot.val().username
//   }volume) / 8)); background: var(--${
//     snapshot.val().username
//   }color); width: var(--${snapshot.val().username}volume); height: var(--${
//     snapshot.val().username
//   }volume)" class="user${snapshot.val().username}"></li>`;
//   // Append the message on the page
//   document.getElementById("messages").innerHTML += message;
// });
// Timeline animations
// QR Code
anime.timeline({}).add({
    targets: "#qrCode",
    opacity: [
        0,
        1
    ],
    // easing: "easeOutExpo",
    duration: 16000,
    delay: 2000
}).add({
    targets: "#qrCode",
    opacity: [
        1,
        0
    ],
    easing: "easeOutExpo",
    duration: 3500
});
// Menu link
anime.timeline({}).add({
    targets: "#information",
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 2000,
    delay: 8000
}).add({
    targets: "#orbs",
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 2500
}, 12500);
// Introduction - desktop
anime.timeline({}).add({
    targets: "#introduction .animateText li:nth-child(1) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 1500,
    delay: (el, i)=>500 + 30 * i
}).add({
    targets: "#introduction .animateText li:nth-child(1) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 1400,
    delay: (el, i)=>100 + 30 * i
}).add({
    targets: "#introduction .animateText li:nth-child(2) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 3000,
    delay: (el, i)=>500 + 30 * i
}, 5000).add({
    targets: "#introduction .animateText li:nth-child(2) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 4000,
    delay: (el, i)=>100 + 30 * i
}).add({
    targets: "#introduction .animateText .helperText .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        0,
        1
    ],
    easing: "easeInExpo",
    duration: 1800,
    delay: (el, i)=>100 + 30 * i
}).add({
    targets: "#introduction .animateText .helperText .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 10000,
    delay: (el, i)=>100 + 30 * i
});
// Introduction - phone
anime.timeline({}).add({
    targets: "#introductionPhone .animateText li:nth-child(1) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 1000,
    delay: (el, i)=>500 + 30 * i
}).add({
    targets: "#introductionPhone .connectButton",
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 1000
}).add({
    targets: "#introductionPhone .animateText li:nth-child(1) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 500,
    delay: (el, i)=>100 + 30 * i
}).add({
    targets: "#introductionPhone .animateText li:nth-child(2) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 1000,
    delay: (el, i)=>500 + 30 * i
}, 5000).add({
    targets: "#introductionPhone .animateText li:nth-child(2) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 1500,
    delay: (el, i)=>100 + 30 * i
});
// // Connect button
// anime
//   .timeline({})
//   .add({
//     targets: "#connect .animateText li:nth-child(1) .letter",
//     translateX: [30, 0],
//     translateZ: 0,
//     opacity: [0, 1],
//     easing: "easeOutExpo",
//     duration: 1900,
//     delay: (el, i) => 500 + 30 * i,
//   })
//   .add({
//     targets: "#connect .animateText li:nth-child(1) .letter",
//     translateX: [0, -30],
//     opacity: [1, 0],
//     easing: "easeInExpo",
//     duration: 1800,
//     delay: (el, i) => 100 + 30 * i,
//   })
//   .add(
//     {
//       targets: "#connect .animateText li:nth-child(2) .letter",
//       translateX: [30, 0],
//       translateZ: 0,
//       opacity: [0, 1],
//       easing: "easeOutExpo",
//       duration: 3000,
//       delay: (el, i) => 500 + 30 * i,
//     },
//     3000,
//   )
//   .add({
//     targets: "#connect .animateText li:nth-child(2) .letter",
//     translateX: [0, -30],
//     opacity: [1, 0],
//     easing: "easeInExpo",
//     duration: 1800,
//     delay: (el, i) => 100 + 30 * i,
//   });
// Introduction - has # in url
anime.timeline({}).add({
    targets: "#hashPhone .animateText li:nth-child(1) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 1900,
    delay: (el, i)=>500 + 30 * i
}).add({
    targets: "#hashPhone .animateText li:nth-child(1) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 1800,
    delay: (el, i)=>100 + 30 * i
}).add({
    targets: "#hashPhone .animateText li:nth-child(2) .letter",
    translateX: [
        30,
        0
    ],
    translateZ: 0,
    opacity: [
        0,
        1
    ],
    easing: "easeOutExpo",
    duration: 3000,
    delay: (el, i)=>500 + 30 * i
}, 3000).add({
    targets: "#hashPhone .animateText li:nth-child(2) .letter",
    translateX: [
        0,
        -30
    ],
    opacity: [
        1,
        0
    ],
    easing: "easeInExpo",
    duration: 1800,
    delay: (el, i)=>100 + 30 * i
});


//# sourceMappingURL=index.2f23b5cf.js.map
